<template>
  <div id="app" :class="{ 'aside-active' : menu_open, 'search-active' : search_open, 'user-content-active' : user_content_active }">

    <app-header-component v-if="(!(this.$router.currentRoute.name == 'login')) && !hide_headers"></app-header-component>

    <main id="main" class="d-md-flex" :class="{ 'page-loading' : page_loading, 'server-blur-effect':server_error }">
    	<app-aside-component v-if="(!(this.$router.currentRoute.name == 'login')) && !hide_headers"></app-aside-component>
		<section class="main-section flex-fill">

			<router-view></router-view>

		</section>
    </main>
    <server-error-view v-if="server_error"></server-error-view>

    <app-footer-component></app-footer-component>

    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import VeeValidate from 'vee-validate';
import axios from 'axios';
import { api } from './api.js';
import { EventBus } from './event_bus.js';

import ServerErrorView from "../src/components/shared/ServerErrorView.vue";

export default {
  name: 'App',
  components:{
    ServerErrorView
  },
  computed : {
    server_error() {
      return this.$store.getters.getServerError;
    },
    menu_open : function(){
      return this.$store.getters.getMenuActive;
    },
    search_open : function(){
      return this.$store.getters.getSearchActive;
    },
    user_content_active : function(){
      return this.$store.getters.getUserContentActive;
    },
    page_loading : function(){
      return this.$store.getters.getPageLoading;
    },
    role : function(){
      return this.$store.getters.getRole;
    },

    hide_headers : function(){
      return  window.location !== window.parent.location
    },
    meta_actions : function(){
      return localStorage.getItem('meta_actions')
    }
  },
   mounted() {
    console.log("MOUNTED");
    var current_url = window.location.href;

    if (current_url.includes("sso") == false) {

      window.onpopstate = event => {
        this.$store.dispatch('checkAccessToken').then((res) => {
        }).catch((error) => {;
        if(this.$router.currentRoute.name != 'forgot-password')
          this.$router.push({ name : 'login' });
      });
      }

      this.$router.beforeEach((to, from, next) => {
        // if user doesnot have permission to see provider detail -  provider list - plain providers. We move them to login page
        try{
          if((to.name.includes('providers.index') || to.name.includes('plain_providers')) && (!this.meta_actions.includes('list_provider'))){
          next({ name: 'Login' })
          }else if(to.name.includes('providers.detail')  && (!this.meta_actions.includes('view_all_provider_details_including_roles'))){
          next({ name: 'Login' })
          }
          else{
            next()
            return
          }

        }catch(e){
          EventBus.$emit('agency_tab_changed', to.path)
        }

      })
  
    }

  },
  created : function() {
    //http://localhost:8081/#/?sso=eVS7xHZjv329XMICdGCAH9Yw1ig2yH4vm798F44SY5I8vh8L2a
    console.log("CREATED");
    var current_url = window.location.href;
    console.log(current_url);

      if (current_url.includes("sso")) {

        console.log("Includes SSO");
        let sso_token= current_url.substring(current_url.indexOf('sso') + 4);
        console.log(sso_token);
        this.checkSSO(sso_token);

      } else {

        if (this.$router.currentRoute.name == 'login') {
          switch(this.role){
            case 'admin' :
              this.$router.push({ name : 'admin.dashboard' }); break;
            case 'organization' :
              if(this.meta_actions.includes('list_provider')){
                this.$router.push({ name : 'organization.providers.index' }); break;
              }else{
                this.$router.push({ name : 'organization.organizations.index' }); break;
              }
            case 'sme' :
              this.$router.push({ name : 'sme.dashboard' }); break;
            case 'csm' :
              if(this.meta_actions.includes('list_provider')){
              this.$router.push({ name : 'csm.providers.index' }); break;
              }else{
              this.$router.push({ name : 'csm.programs.index' }); break;
              }
          }
        }

          /* CUSTOM VALIDATORS FOR VEE-VALIDATE */
          //define validation email on create
          VeeValidate.Validator.extend('email_unique', {
            getMessage: field => `The email ${field} has already been taken.`, //usamos las comillas monguers
            validate: value => new Promise((resolve) => {
              this.$store.dispatch('emailExists', { email : value, filters : { page_loading : false } }).then( (res) => {
                resolve({
                  valid : !res.data.result
                })
              });
            })
          });

          //define validation email on update
          VeeValidate.Validator.extend('email_unique_update', {
            getMessage: field => `The email ${field} has already been taken.`, //usamos las comillas monguers
            validate: (value, params) => new Promise((resolve) => {
              this.$store.dispatch('emailExists', { email : value, filters : { page_loading : false, user_id : params[0] } }).then( (res) => {
                resolve({
                  valid : !res.data.result
                })
              });
            })
          });

          //define ssn validation on create
          VeeValidate.Validator.extend('ssn_unique', {
            getMessage: field => `The ssn ${field} has already been taken.`, //usamos las comillas monguers
            validate: value => new Promise((resolve) => {
              this.$store.dispatch('ssnExists', { ssn : value, filters : { page_loading : false } }).then( (res) => {
                resolve({
                  valid : !res.data.result
                })
              });
            })
          });

          //define ssn validation on update
          VeeValidate.Validator.extend('ssn_unique_update', {
            getMessage: field => `The ssn ${field} has already been taken.`, //usamos las comillas monguers
            validate: value => new Promise((resolve) => {
              this.$store.dispatch('ssnExists', { ssn : value, filters : { page_loading : false, provider_id : params[0] } }).then( (res) => {
                resolve({
                  valid : !res.data.result
                })
              });
            })
          });
       }

  },
  methods : {
    checkSSO(sso_token) {
      console.log("SSO CHECK");
      this.$store.dispatch('loginSSO', {
          sso : sso_token
        }).then(res => {
          this.$store.dispatch('checkAccessToken').then((res) => {
            this.$router.push({ name : 'login' });

            setTimeout(function() {
              window.location.reload();
            }, 500);
          }).catch((error) => {
            console.log(error);
          });
        });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue